export default __webpack_public_path__ + "static/media/milestone 1000.8235c3f4.svg";